<template>
  <v-icon
    id="connection-indicator"
    :class="online ? 'connection-indicator--online' : 'connection-indicator--offline'"
    :aria-label="$t(statusToken)"
    :title="$t(statusToken)"
    role="img"
  >
    {{ online ? icons.mdiWifi : icons.mdiWifiOff }}
  </v-icon>
</template>

<script>
  import icons from '@/mixins/icons'
  import { useConnectionStatus } from '@/composables/useConnectionStatus'
  import './styles/connection-indicator.css'

  export default {
    name: 'ConnectionIndicator',
    mixins: [icons],
    setup() {
      const { online, statusToken } = useConnectionStatus()
      return { online, statusToken }
    },
  }
</script>

